export const completeTask = (id: number) => ({
    type: "COMPLETE_TASK",
    payload: id
});